if (!customElements.get('ff-calculadora-racion')) {
  class FFCalculadoraRacion extends HTMLElement {
    connectedCallback() {
      this.weightInput = this.querySelector('[data-ff-weight]');
      this.alertBox = this.querySelector('[data-ff-alert-box]');
      this.gramsEl = this.querySelector('[data-ff-grams]');
      this.mealsEl = this.querySelector('[data-ff-meals]');
      this.perMealEl = this.querySelector('[data-ff-per-meal]');
      this.formulaEl = this.querySelector('[data-ff-formula]');

      const locale = this.dataset.locale || document.documentElement.lang;
      this.integerFormat = new Intl.NumberFormat(locale, { maximumFractionDigits: 0 });
      this.decimalFormat = new Intl.NumberFormat(locale, { maximumFractionDigits: 1 });

      this.onChange = this.onChange.bind(this);
      this.onInput = this.onInput.bind(this);
      this.addEventListener('change', this.onChange);
      this.addEventListener('input', this.onInput);
      this.render();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('input', this.onInput);
    }

    get group() {
      return (
        this.querySelector('[data-ff-group]:checked')?.value || this.querySelector('[data-ff-cases]')?.dataset.ffCases
      );
    }

    get selectedCase() {
      return this.querySelector(`[data-ff-cases="${this.group}"] input:checked`);
    }

    onChange(event) {
      if (event.target.matches('[data-ff-group]')) {
        this.querySelectorAll('[data-ff-cases]').forEach((fieldset) => {
          fieldset.hidden = fieldset.dataset.ffCases !== this.group;
        });
      }
      this.render();
    }

    // Maximo 3 enteros y 1 decimal; acepta coma porque en ES/PT es el separador que teclea el cliente.
    onInput(event) {
      if (!this.weightInput || event.target !== this.weightInput) return;
      const raw = String(this.weightInput.value).replace(/[^0-9.,]/g, '').replace(',', '.');
      const [integer, fraction] = raw.split('.');
      const clean = fraction === undefined ? integer.slice(0, 3) : `${integer.slice(0, 3)}.${fraction.slice(0, 1)}`;
      if (clean !== this.weightInput.value) this.weightInput.value = clean;
      this.render();
    }

    render() {
      const option = this.selectedCase;
      if (!option) return;

      if (this.alertBox) this.alertBox.hidden = !option.hasAttribute('data-ff-alert');
      if (!this.weightInput || !this.gramsEl) return;

      const min = parseFloat(option.dataset.min);
      const max = parseFloat(option.dataset.max);
      const meals = parseInt(option.dataset.meals, 10);
      const average = (min + max) / 2;
      const weight = parseFloat(this.weightInput.value) || 0;
      const total = weight * average * 10;
      const hasWeight = weight > 0;
      const grams = hasWeight ? this.integerFormat.format(Math.round(total)) : '—';

      this.gramsEl.textContent = grams;
      if (this.mealsEl) {
        this.mealsEl.textContent = `${meals} ${meals === 1 ? this.dataset.mealOne : this.dataset.mealOther}`;
      }
      if (this.perMealEl) {
        this.perMealEl.textContent = hasWeight ? `${this.integerFormat.format(Math.round(total / meals))} g` : '—';
      }
      if (this.formulaEl) {
        this.formulaEl.textContent = hasWeight
          ? this.dataset.formula
              .replace('[weight]', this.decimalFormat.format(weight))
              .replace('[percent]', this.decimalFormat.format(average))
              .replace('[grams]', grams)
          : this.dataset.formulaEmpty;
      }
    }
  }

  customElements.define('ff-calculadora-racion', FFCalculadoraRacion);
}
